import {DialectService} from './dialect.service';
import {DialectBookmarkService} from './dialect-bookmark.service';
import {DialectHistoryService} from './dialect-history.service';

export const DialectInjectables: Array<any> = [
  {
    provide: DialectService,
    useClass: DialectService,
  },
  {
    provide: DialectBookmarkService,
    useClass: DialectBookmarkService,
  },
  {
    provide: DialectHistoryService,
    useClass: DialectHistoryService,
  },
];
